module.exports = __webpack_public_path__ + "static/img/product14.19016b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product14.png
// module id = Q71T
// module chunks = 13